import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { DEFAULT_WIDGET_HEIGHT, WIDGET_MARGIN } from "@webapp/home/models/home-widgets.models";
import { HomeWidgetService } from "@webapp/home/services/home-widget.service";
import { UiDashboardElementEvent, UiDashboardNodesEvent, UiDashboardOptions, UiDashboardWidget } from "@webapp/ui/dashboard/dashboard.models";
import { nodeToWidget } from "./home-dashboard.utils";

@UntilDestroy()
@Component({
  selector: "home-dashboard",
  templateUrl: "./home-dashboard.component.html",
  styleUrls: ["./home-dashboard.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "new-layout-page",
  },
})
export class HomeDashboardComponent implements OnInit {
  public dashboardOptions: UiDashboardOptions = {
    margin: WIDGET_MARGIN,
    column: 2,
    cellHeight: 1,
    resizable: { handles: " " }, // disallow resizing using the mouse
  };

  public dashboardWidgets: UiDashboardWidget[] = [];

  constructor(private homeWidgetService: HomeWidgetService, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.homeWidgetService
      .getDashboardWidgets$()
      .pipe(untilDestroyed(this))
      .subscribe((dashboardWidgets) => {
        this.dashboardWidgets = dashboardWidgets;
        this.cdr.detectChanges();
      });
  }

  public onChange($event: UiDashboardNodesEvent): void {
    this.homeWidgetService.handleWidgetsChange($event.nodes.map(nodeToWidget));
  }

  public onResize($event: UiDashboardElementEvent): void {
    let shouldChange = false;
    const resizedWidget = nodeToWidget($event.el.gridstackNode);
    if (resizedWidget.w === 1 && resizedWidget.minH !== DEFAULT_WIDGET_HEIGHT) {
      resizedWidget.minH = DEFAULT_WIDGET_HEIGHT;
      shouldChange = true;
    } else if (resizedWidget.w === 2 && typeof resizedWidget.minH !== "undefined") {
      resizedWidget.minH = undefined;
      shouldChange = true;
    }

    if (shouldChange) {
      const existingWidgetIndex = this.dashboardWidgets.findIndex((w) => w.id === resizedWidget.id);
      const updatedWidgets = [...this.dashboardWidgets];
      updatedWidgets[existingWidgetIndex] = resizedWidget;
      this.homeWidgetService.handleWidgetsChange(updatedWidgets);
    }
  }
}
